(function () {
	'use strict';

	angular
		.module('core.components')
		.controller('FirstAccessController', FirstAccessController)

	/** @ngInject */
	function FirstAccessController($rootScope, PreRegistraterService, LoadingHelper, ValidatorHelper, UtilHelper, sweetAlert) {
		const vm = this;

		vm.passwordValidator = ValidatorHelper.validatePassword;

		vm.firstAccess = () => {
			if (!validateDate())
				return;

			if (!vm.firstAccessData.Documents.find(x => x.DocumentTypeId == 1)) {
				sweetAlert.swal({
					title: 'Aviso',
					text: 'Você também deve informar o seu CPF no cadastro!',
					type: 'warning',
					confirmButtonText: 'Ok',
					showCancelButton: false,
					allowOutsideClick: false,
					allowEscapeKey: false
				})

				LoadingHelper.stopLoading('.loading-holder');
				return;
			}

			LoadingHelper.startLoading('.loading-holder');

			let personData = {
				Name: vm.firstAccessData.Name,
				GenderId: vm.firstAccessData.GenderId,
				BirthDate: vm.firstAccessData.BirthDate.Date,
				Password: Encrypt.Hash(vm.firstAccessData.Password).toString(),
				PreRegisterId: vm.firstAccessData.PreRegisterId
			};

			let personDocuments = vm.firstAccessData.Documents.reduce((acc, cur) => {
				acc.push({
					DocumentTypeId: cur.DocumentTypeId,
					Code: cur.Code
				})

				return acc;
			}, []);

			personData.PersonDocuments = personDocuments;
			personData.PersonEmails = vm.firstAccessData.Emails;
			personData.PersonPhones = vm.firstAccessData.Telephones;

			PreRegistraterService
				.registerPerson(personData)
				.then(success => {
					if (success) {
						vm.step = 3;
						LoadingHelper.stopLoading('.loading-holder');
					} else {
						UtilHelper.errorCallback(success);
						LoadingHelper.stopLoading('.loading-holder');
					}
				}, error => {
					UtilHelper.errorCallback(error);
					LoadingHelper.stopLoading('.loading-holder');
				})
		}

		vm.getPreRegister = () => {
			LoadingHelper.startLoading('.loading-holder');

			PreRegistraterService
				.getPreRegistration(vm.preRegisterData.PinCode)
				.then(success => {
					vm.firstAccessData.PreRegisterId = success.Id;
					vm.firstAccessData.Name = success.Name;
					vm.firstAccessData.Emails[0] = {
						Email: success.Email
					};

					vm.step = 2;

					$rootScope.authenticationWrapperLarger = true;

					LoadingHelper.stopLoading('.loading-holder');
				}, error => {
					UtilHelper.errorCallback(error);
					LoadingHelper.stopLoading('.loading-holder');
				})
		}

		init();

		function validateDate() {
			let isValid = ValidatorHelper.validateDate(vm.firstAccessData.BirthDate.Formatted);

			if (isValid)
				vm.firstAccessData.BirthDate.Date = UtilHelper.convertToMomentDate(vm.firstAccessData.BirthDate.Formatted).format('YYYY-MM-DD');

			return isValid;
		}

		function init() {
			$rootScope.authenticationWrapperLarger = false;
			vm.step = 1;

			vm.preRegisterData = {};

			vm.firstAccessData = {
				Emails: [],
				Telephones: [],
				Documents: [{
					DocumentTypeId: 1
				}]
			};
		}
	}
}());